import { render, staticRenderFns } from "./emptyEventsList.vue?vue&type=template&id=aca426d2&scoped=true&"
import script from "./emptyEventsList.vue?vue&type=script&lang=js&"
export * from "./emptyEventsList.vue?vue&type=script&lang=js&"
import style0 from "./emptyEventsList.vue?vue&type=style&index=0&id=aca426d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aca426d2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
